export default {
    'Internal media storage is empty.': 'Der interne Medienspeicher ist leer.',
}